import _ from 'lodash';
import Slider from 'rc-slider';
// Slider
import 'rc-slider/assets/index.css';
// Shared
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-translate';
import { compose } from 'redux';
import { Button, Container, Form, Grid, Header, Icon, Image, Modal, Segment, GridRow } from 'semantic-ui-react';
import LegendGrey from '../../assets/img/LegendGrey.png';
import envList from '../../constants/envList';
import PDFService, { PageType } from '../../services/PDFService';
import HeaderComponent from '../shared/HeaderComponent';
import './LandingComponent.css';
import ImageDisplayer from './projet/imageDisplayer';
import JobList from './projet/jobList';
import productInfos from './projet/productInfos';

const { Handle } = Slider;

const epaisseurOptions = [
  { key: 60, value: 60, text: 60 },
  { key: 80, value: 80, text: 80 },
  { key: 100, value: 100, text: 100 },
  { key: 120, value: 120, text: 120 },
  { key: 140, value: 140, text: 140 },
  { key: 200, value: 200, text: 200 },
];

const stateOptions = [
  { key: 'Monocouche', value: 'Monocouche', text: 'value_dropdown_monocouche' },
  { key: 'Bicouche', value: 'Bicouche', text: 'value_dropdown_bicouche' },
];

const handle = (props) => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Tooltip
      prefixCls="rc-slider-tooltip"
      overlay={value}
      visible={dragging}
      placement="top"
      key={index}
    >
      <Handle value={value} {...restProps} />
    </Tooltip>
  );
};

class LandingComponent extends Component {
  constructor(props) {
    super(props);
    const { match: { params: { env } }, location } = props;
    const { haveBicouche } = productInfos[env];
    this.state = {
      isoValue: null,
      distEntreChevrons: 80,
      distSousChevrons: 60,
      resValue: productInfos[env].defaultThermicalResist,
      corpInfo: {},
      projectInfo: {},
      headerVisible: true,
      showMonocouche: !haveBicouche,
      epaisseurChevron: 100,
      modalOpen: false,
      needBicouche: haveBicouche,
    };

    if (location && location.state) {
      this.state = {
        ...this.state,
        ...this.props.location.state,
      };
    }
  }

  componentWillMount() {
    window.scrollTo(0, 0);
    // this.state.showMonocouche = true;

    const { t } = this.props;
    let stateOptionsCopy = _.clone(stateOptions);
    stateOptionsCopy = _.map(stateOptionsCopy, x => ({
      ...x,
      text: t(x.text),
    }));
    this.setState({
      stateOptions: stateOptionsCopy,
    });
  }

  handleOpen = () => this.setState({ modalOpen: true });

  handleClose = () => this.setState({ modalOpen: false, showMonocouche: false });


  getJob = () => {
    const token = sessionStorage.getItem('USER_TOKEN');
    if (token) {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace('-', '+').replace('_', '/');
      const tmp = JSON.parse(window.atob(base64));
      return tmp.job;
    }

    return JobList.USER;
  };

  screenPage() {
    const { match: { params: { env } }, history } = this.props;
    const {
      isoValue,
      tarifMoStandard,
      calculHourStandard,
      epaisseurChevron,
      resValue,
      showMonocouche,
    } = this.state;


    if (
      envList.isCA(env)
      && ((epaisseurChevron === 60 && resValue === 10)
      || resValue === 10
      || (resValue >= 9
        && showMonocouche === false
        && epaisseurChevron === 60)
      || (resValue >= 9.5
        && showMonocouche === false
        && epaisseurChevron === 80))
    ) {
      this.setState({ modalOpen: true });
    } else {
      PDFService.screenPage(PageType.LANDING).then(() => {
        history.push({
          pathname: `/${env}/compare`,
          state: {
            isoValue,
            tarifMoStandard,
            calculHourStandard,
            showMonocouche,
            epaisseurChevron,
            resValue,
          },
        });
      });
      this.setState({ modalOpen: false });
    }
  }

  dropdownMonoBiCouche(__, val) {
    const showMonoBi = val.value;

    if (showMonoBi === 'Monocouche') {
      this.setState({ showMonocouche: true });
      setTimeout(() => {
      }, 2000);
    } else {
      this.setState({ showMonocouche: false });
      setTimeout(() => {
      }, 2000);
    }
  }

  drawImageDisplayer() {
    const jobId = this.getJob();
    const { match: { params: { env } }, t } = this.props;
    const { showMonocouche } = this.state;
    const displayers = [];
    const descriptions = [];

    Object.values(productInfos[env].formula).forEach((productInfo) => {
      displayers.push(
        <ImageDisplayer
          image={showMonocouche ? productInfo.img : productInfo.bicoucheImg}
          key={productInfo.id}
          id={productInfo.id}
          title={t(productInfo.titleKey)}
        />
      );

      descriptions.push(
        <Grid.Column className={`tabCell ${productInfo.class}`} key={productInfo.id}>
          <div className="rowText">
            {t(productInfo.descriptionKey[jobId])}
          </div>
        </Grid.Column>
      );
    });

    return (
      <Grid columns="equal" id="tabContainer">
        <Grid.Row>
          <Grid.Column id="emptyHeader" width={2} />
          {displayers}
        </Grid.Row>
        <GridRow>
          <Grid.Column className="rowHeader" width={2}>
            <div className="rowHeaderText">
              {t('solution_description')}
            </div>
          </Grid.Column>
          {descriptions}
        </GridRow>
      </Grid>
    );
  }

  drawSlider() {
    const { t, match: {params: { env }} } = this.props;
    const { resValue } = this.state;
    const { maxThermicalResist, minThermicalResist, thermicalMarks, backgroundStyle } = productInfos[env];

    const style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = `.projectFrame #sliderContainer .rc-slider-rail {
      height: 15px;
      background: rgb(227, 36, 20); /* Old browsers */
      background: -moz-linear-gradient(
        left,
        ${backgroundStyle}
      ); /* FF3.6-15 */
      background: -webkit-linear-gradient(
        left,
        ${backgroundStyle}
      ); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(
        to right,
        ${backgroundStyle}
      ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e32414', endColorstr='#01782d',GradientType=1 ); /* IE6-9 */
    }`;
    document.getElementsByTagName('head')[0].appendChild(style);

    const marks = {
      [thermicalMarks[0].value]: {
        style: { width: '31%', left: thermicalMarks[0].pos, top: '8px' },
        label: env === envList.CA.path ? t('second_value_slider') : '',
      },
      [thermicalMarks[1].value]: {
        style: { width: '30%', left: thermicalMarks[1].pos, top: '8px' },
        label: env === envList.CA.path ? t('third_value_slider') : t('second_value_slider'),
      },
      [thermicalMarks[2].value]: {
        style: { width: '65%', left: thermicalMarks[2].pos, top: '8px' },
        label: env === envList.CA.path ? t('fourth_value_slider') : t('third_value_slider'),
      },
    };

    if (env === envList.IME.path) {
      marks[thermicalMarks[3].value] = {
        style: { width: '65%', left: thermicalMarks[3].pos, top: '8px' },
        label: t('fourth_value_slider'),
      };
    }

    return (
      <Slider
        id="slider"
        step={productInfos[env].step}
        min={minThermicalResist}
        max={maxThermicalResist}
        value={resValue}
        trackStyle={{ height: 15 }}
        marks={marks}
        included
        handle={handle}
        onChange={val => this.setState({ resValue: val })}
      />
    );
  }

  render() {
    const { t, history, match: { params: { env } } } = this.props;
    const { needBicouche, showMonocouche, headerVisible } = this.state;
    const { thermicalMarks } = productInfos[env];

    return (
      <div>
        <HeaderComponent
          currentPage={1}
          commonState={this.state}
          shown={headerVisible}
          history={history}
        />
        <Container className="projectPage">
          <Segment className="projectFrame">
            <Container as="h2" className="frameTitle">
              {t(productInfos[env].titleKey)}
              {/* Comparateur solutions KNAUF INSULATION en combles aménagés{" "} */}
            </Container>
            {this.drawImageDisplayer()}
            <Form className="corpForm">
              <Form.Input
                label={t('project_name_entreprise')}
                placeHolder=""
                value={this.state.corpInfo.name}
                onChange={(_e, v) => {
                  const { corpInfo } = this.state;
                  corpInfo.name = v.value;
                  this.setState({ corpInfo });
                }}
              />
              <Form.Input
                label={t('entreprise_address')}
                placeHolder=""
                value={this.state.corpInfo.address}
                onChange={(__, v) => {
                  const { corpInfo } = this.state;
                  corpInfo.address = v.value;
                  this.setState({ corpInfo });
                }}
              />
              <Form.Group widths="equal">
                <Form.Input
                  label={t('entreprise_cp')}
                  placeHolder=""
                  value={this.state.corpInfo.postalCode}
                  onChange={(e, v) => {
                    const { corpInfo } = this.state;
                    corpInfo.postalCode = v.value;
                    this.setState({ corpInfo });
                  }}
                />
                <Form.Input
                  label={t('entreprise_town')}
                  placeHolder=""
                  value={this.state.corpInfo.city}
                  onChange={(__e, v) => {
                    const { corpInfo } = this.state;
                    corpInfo.city = v.value;
                    this.setState({ corpInfo });
                  }}
                />
              </Form.Group>
            </Form>
            <Form className="corpForm" id="projectDescForm">
              <Form.Input
                label={t('project_description')}
                placeHolder=""
                value={this.state.projectInfo.description}
                onChange={(e, v) => {
                  const { projectInfo } = this.state;
                  projectInfo.description = v.value;
                  this.setState({ projectInfo });
                }}
              />
              <Form.Input
                label={t('project_name')}
                placeHolder=""
                value={this.state.projectInfo.name}
                onChange={(e, v) => {
                  const { projectInfo } = this.state;
                  projectInfo.name = v.value;
                  this.setState({ projectInfo });
                }}
              />
              <Form.Input
                label={t('project_address')}
                placeHolder=""
                value={this.state.projectInfo.address}
                onChange={(e, v) => {
                  const { projectInfo } = this.state;
                  projectInfo.address = v.value;
                  this.setState({ projectInfo });
                }}
              />
              <Form.Group widths="equal">
                <Form.Input
                  label={t('project_cp')}
                  placeHolder=""
                  value={this.state.projectInfo.postalCode}
                  onChange={(e, v) => {
                    const { projectInfo } = this.state;
                    projectInfo.postalCode = v.value;
                    this.setState({ projectInfo });
                  }}
                />
                <Form.Input
                  label={t('project_ville')}
                  placeHolder=""
                  value={this.state.projectInfo.city}
                  onChange={(e, v) => {
                    const { projectInfo } = this.state;
                    projectInfo.city = v.value;
                    this.setState({ projectInfo });
                  }}
                />
              </Form.Group>
            </Form>
            <Form className="corpForm" id="isoValuesForm">
              <Form.Group widths="equal">
                <Form.Input
                  type="number"
                  required
                  label={t('isolated_surface')}
                  placeHolder=""
                  value={this.state.isoValue}
                  min="0"
                  error={
                    this.state.isoValue == null || this.state.isoValue === 0
                  }
                  onChange={(___, val) => { 
                    this.setState({ isoValue: Number(val.value) });
                  }}
                />
                <Form.Button id="isoUnit" label="unit">
                  {' '}
                  {t('isolated_surface_unit_value')}
                  {' '}
                </Form.Button>
                {needBicouche && (
                  <Form.Dropdown
                    label={t('dropdown_monobi')}
                    placeholder="Isolant"
                    selection
                    options={this.state.stateOptions || []}
                    onChange={(e, val) => this.dropdownMonoBiCouche(e, val)}
                    required
                    defaultValue={
                      this.state.showMonocouche === true
                        ? stateOptions[0].value
                        : stateOptions[1].value
                    }
                  />
                )}
                {needBicouche && (
                  <Form.Button id="resUnit" label="unit">
                    {' '}
                    {t('unité_monocouche_bicouche')}
                    {' '}
                  </Form.Button>
                )}
              </Form.Group>
              {!showMonocouche && (
                <Form.Group style={{ width: '250px' }}>
                  <Form.Dropdown
                    style={{ width: '250px' }}
                    required
                    label="Epaisseur du chevron"
                    value={this.state.epaisseurChevron}
                    selection
                    onChange={(e, val) => this.setState({ epaisseurChevron: Number(val.value) })
                      }
                    options={epaisseurOptions}
                  />
                  <Form.Button
                    id="resUnit"
                    label="unit"
                    style={{ width: '100px' }}
                  >
                    {' '}
                    {t('dist_sous_chevrons_unit_value')}
                    {' '}
                  </Form.Button>
                </Form.Group>
              )}
            </Form>
            <Segment id="sliderContainer">
              <Segment basic id="sliderText">
                {t('resist_choice')}
              </Segment>
              {this.drawSlider()}
              {thermicalMarks[3] && (
                <p className={thermicalMarks[3].className}>
                  {t(thermicalMarks[3].titleKey)}
                </p>
              )}
              <p className={thermicalMarks[2].className}>
                {t(thermicalMarks[2].titleKey)}
              </p>
              <p className={thermicalMarks[1].className}>
                {t(thermicalMarks[1].titleKey)}
              </p>
              <p className={thermicalMarks[0].className}>
                {t(thermicalMarks[0].titleKey)}
              </p>
            </Segment>
            <Segment id="legendContainer">
              <Header id="sliderLegend">
                {' '}
                {t('project_legend')}
              </Header>
              <Image src={LegendGrey} alt="Legende" />
            </Segment>
            <Container
              style={{
                textAlign: 'right',
                marginTop: '35px',
                marginBottom: '25px',
                width: '97%',
              }}
            >
              <Button
                id="btnNext"
                className="nextBtn"
                size="big"
                disabled={
                  this.state.isoValue == null
                  || this.state.isoValue <= 0
                  || this.state.distEntreChevrons <= 0
                  || this.state.distSousChevrons <= 0
                  || this.state.resValue <= 0
                }
                onClick={() => this.screenPage()}
              >
                {t('project_next_button')}
                <Icon name="long arrow alternate right" />
              </Button>
              {/* </Link> */}
            </Container>
            <Modal
              id="ModalExportMail"
              open={this.state.modalOpen}
              onClose={this.handleClose}
            >
              <Header
                icon="times"
                color="red"
                content={t('title_modal_impossible_configuration')}
              />
              <Modal.Content>
                <h3>{t('incompatible_modal_epaisseur_resistance')}</h3>
              </Modal.Content>
              <Modal.Actions>
                <Button color="red" onClick={this.handleClose} inverted>
                  <Icon name="checkmark" />
                  {' '}
                  {t('incompatible_modal_ok')}
                </Button>
              </Modal.Actions>
            </Modal>
          </Segment>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  app: state.app,
});

export default compose(
  connect(mapStateToProps),
  translate('LandingComponent')
)(LandingComponent);



// WEBPACK FOOTER //
// ./src/components/Protected/LandingComponent.jsx